import { defineVuexModule } from '../helpers';

export type POS = {
  id: number;
  // name: string;
  // type: string;
  // capacity: number;
  color: string;
};

export default defineVuexModule({
  namespaced: true,
  state: {
    pos: [] as POS[],
    unassignedCount: 0,
    assignedList: [],
  },

  getters: {},

  actions: {
    loadPosList(context, poslist) {
      context.commit('updatePosList', poslist);
    },
    addPos(context, pos) {
      context.commit('addPos', pos);
    },
    updateAssignedList(context, posStats) {
      context.commit('updateAssignedList', posStats);
    },
    changeUnassignedCount(context, count) {
      context.commit('changeUnassignedCount', count);
    },
  },

  mutations: {
    updatePosList(state, posList) {
      state.pos = posList;
    },
    addPos(state, pos) {
      state.pos = [...state.pos, pos];
    },
    updateAssignedList(state, assignedList) {
      state.assignedList = assignedList;
    },
    changeUnassignedCount(state, count) {
      state.unassignedCount = count;
    },
  },
});
